import { Component, OnInit, ViewChild } from '@angular/core';
import { Roteiro } from '../../comum/modelos/roteiro';
import { Paginacao } from '../../comum/modelos/paginacao';
import { RoteiroService } from '../roteiro.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-selecao-roteiro',
  templateUrl: './listar-roteiro.component.html',
  styleUrls: ['./listar-roteiro.component.css']
})
export class ListarRoteiroComponent implements OnInit {
  @ViewChild('tabset', { read: NgbTabset, }) tabset: NgbTabset;

  filtroPesquisaNomeRoteiro: string;

  roteiros: Roteiro[];

  paginacao: Paginacao;

  evento: Evento;

  public loading = false;

  statusCode: number;

  constructor(private _roteiroService: RoteiroService,
    private _comumService: ComumService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();

    this.roteiros = new Array<Roteiro>();
    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => { this._comumService.cleanEvent(); }, 2000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.fetchData();
  }



  removerRoteiro(roteiro: Roteiro): void {
    const self = this;
    this.confirmationService.confirm({
      message: 'Deseja excluir este roteiro?',
      accept: () => {
        self.loading = true;
        self._roteiroService.removerPontosFisicosRoteiroHttp(roteiro.pontosFisicos)
          .subscribe(response => {
            self._roteiroService.apagarRoteiroHttp(roteiro.idRoteiro)
              .subscribe(resp => {
                self.loading = false;
                self.statusCode = resp.status;
                self.roteiros = new Array<Roteiro>();
                self.fetchData();
              }, errorCode => {
                self.statusCode = errorCode;
                self.loading = false;
              });
            self.loading = false;
            self.statusCode = response.status;
            self._comumService.evento.deletar = true;
            self.router.navigate(['listar-roteiros']);
            setTimeout(() => {
              self._comumService.evento.limparEventos();
            }, 3000);
          }, errorCode => {
            self.statusCode = errorCode;
            self.loading = false;
          });
      },
      reject: () => {
      }
    });
  }

  fetchData() {
    this.loading = true;

    this._roteiroService.obterRoteirosClienteHttp(parseInt(this._cookieService.get('idCliente'), 10))
      .subscribe((roteiros: Roteiro[]) => {
        roteiros.forEach(roteiro => {
          this._roteiroService.obterPontosFisicosRoteiroHttp(roteiro.idRoteiro)
            .subscribe((pontosFisicos) => {
              roteiro.pontosFisicos = pontosFisicos;
              this.roteiros.push(roteiro);
            });
        });
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeRoteiro = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  voltar(): void {
    if (this.tabset) {
      this.tabset.select('roteiro');
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/listar-roteiro/listar-roteiro.component.ts